export const SET_USER = 'SET_USER';

// shifts
export const SET_SHIFT_LIST = 'SET_SHIFT_LIST';

// tags
export const SET_TAX_LIST = 'SET_TAX_LIST';
export const SET_TAX = 'SET_TAX';
export const SET_TAX_ATTRIBUTE = 'SET_TAX_ATTRIBUTE';

// products
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';

// tags
export const SET_TAG_LIST = 'SET_TAG_LIST';
export const SET_TAG_ATTRIBUTE = 'SET_TAG_ATTRIBUTE';
export const SET_TAG = 'SET_TAG';
export const ADD_TAG = 'ADD_TAG';
export const SET_TREE_TAG = 'SET_TREE_TAG';

// categories
export const SET_CATEGORY_LIST = 'SET_CATEGORY_LIST';
export const ADD_CATEGORY = 'ADD_CATEGORY';

// regions
export const SET_REGION_LIST = 'SET_REGION_LIST';
export const ADD_REGION = 'ADD_REGION';

// labels
export const SET_LABEL_LIST = 'SET_LABEL_LIST';
export const ADD_LABEL = 'ADD_LABEL';

// cards
export const SET_CARD_LIST = 'SET_CARD_LIST';

export const SET_EPS_CARD_LIST = 'SET_EPS_CARD_LIST';

export const SET_SHELL_APP_CARD_LIST = 'SET_SHELL_APP_CARD_LIST';

// tiers
export const SET_TIER_LIST = 'SET_TIER_LIST';
export const ADD_TIER = 'ADD_TIER';
export const ADD_ASSIGN_STATION = 'ADD_ASSIGN_STATION';

// trading_area
export const SET_TRADING_AREA_LIST = 'SET_TRADING_AREA_LIST';
export const ADD_TRADING_AREA = 'ADD_TRADING_AREA';

// zones
export const SET_ZONE_LIST = 'SET_ZONE_LIST';
export const ADD_ZONE = 'ADD_ZONE';

// modifiers
export const SET_MODIFIER_SET_LIST = 'SET_MODIFIER_SET_LIST';
export const ADD_MODIFIER_SET = 'ADD_MODIFIER_SET';
export const SET_MODIFIER_SET = 'SET_MODIFIER_SET';
export const ADD_MODIFIER = 'ADD_MODIFIER';
export const REMOVE_MODIFIER = 'REMOVE_MODIFIER';
export const SET_MODIFIER_SET_ATTRIBUTE = 'SET_MODIFIER_SET_ATTRIBUTE';
export const SET_MODIFIERS_SEQUENCE = 'SET_MODIFIERS_SEQUENCE';
export const SET_MODIFIERS = 'SET_MODIFIERS';

// receipts
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const SET_REFUND_ID = 'SET_REFUND_ID';
export const SET_VOIDED = 'SET_VOIDED';

// report product
export const SET_TOP_PURCHASE_BY_TAGS = 'SET_TOP_PURCHASE_BY_TAGS';
export const SET_TOP_PURCHASE_PRODUCTS = 'SET_TOP_PURCHASE_PRODUCTS';
export const SET_TOP_GROSING_PRODUCTS = 'SET_TOP_GROSING_PRODUCTS';

// drawer session report
export const SET_DRAWER_SESSION = 'SET_DRAWER_SESSION';
export const ADD_CORRECTION_DRAWER_SESSION = 'ADD_CORRECTION_DRAWER_SESSION';

//till summary
export const SET_TILL_SUMMARY = 'SET_TILL_SUMMARY';

//daily sales report
export const SET_DAILY_SALES = 'SET_DAILY_SALES';

//lkh report
export const SET_COLLECTED_SALES = 'SET_COLLECTED_SALES';
export const ADD_COLLECTED_SALES = 'ADD_COLLECTED_SALES';
export const STATUS_COLLECTED_SALES = 'STATUS_COLLECTED_SALES';

// central settings

//local account
export const SET_LOCAL_ACCOUNT_LIST = 'SET_LOCAL_ACCOUNT_LIST';
export const ADD_LOCAL_ACCOUNT = 'ADD_LOCAL_ACCOUNT';
export const ADD_VEHICLE = 'ADD_VEHICLE';
export const ADD_TOPUP = 'ADD_TOPUP';

// supplier
export const SET_SUPPLIER_LIST = 'SET_SUPPLIER_LIST';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const SET_SUPPLIER_ATTR = 'SET_SUPPLIER_ATTR';

// stock receive
export const SET_STOCK_RECEIVE = 'SET_STOCK_RECEIVE';
export const SET_STOCK_RECEIVE_ATTR = 'SET_STOCK_RECEIVE_ATTR';
export const ADD_RECEIVE_STOCK = 'ADD_RECEIVE_STOCK';
export const UPDATE_RECEIVE_STOCK = 'UPDATE_RECEIVE_STOCK';

// stock receive & stock check & stock return
export const SET_STOCK_MOVEMENT = 'SET_STOCK_MOVEMENT';
export const SET_STOCK_MOVEMENT_ATTR = 'SET_STOCK_MOVEMENT_ATTR';
export const ADD_STOCK_MOVEMENT_PRODUCT = 'ADD_STOCK_MOVEMENT_PRODUCT';
export const UPDATE_STOCK_MOVEMENT_PRODUCT = 'UPDATE_STOCK_MOVEMENT_PRODUCT';
export const REMOVE_STOCK_MOVEMENT_PRODUCT = 'REMOVE_STOCK_MOVEMENT_PRODUCT';
export const SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL =
    'SAVE_STOCK_MOVEMENT_PRODUCT_DETAIL';
export const REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL =
    'REMOVE_STOCK_MOVEMENT_PRODUCT_DETAIL';
export const SET_STOCK_RECEIVE_LIST = 'SET_STOCK_RECEIVE_LIST';

// promotion
export const SET_PROMOTION_LIST = 'SET_PROMOTION_LIST';

// meta
export const SET_METADATA_LIST = 'SET_METADATA_LIST';

// fuel
export const UPDATE_FUEL_DIPPING_MOVEMENT = 'UPDATE_FUEL_DIPPING_MOVEMENT';
export const UPDATE_FUEL_DIPPING_DETAIL = 'UPDATE_FUEL_DIPPING_DETAIL';
export const RESET_FUEL_DIPPING_DETAILS = 'RESET_FUEL_DIPPING_DETAILS';
export const ADD_FUEL_DIPPING_DETAIL = 'ADD_FUEL_DIPPING_DETAIL';
export const INITIALIZE_GROUP_DETAILS = 'INITIALIZE_GROUP_DETAILS';
export const UPDATE_GROUP_DETAILS = 'UPDATE_GROUP_DETAILS';
export const RESET_GROUP_DETAILS = 'RESET_GROUP_DETAILS';

// virtual shift
export const SET_VIRTUAL_SHIFT = 'SET_VIRTUAL_SHIFT';
